var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlxsDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.99,
    height: 61.908,
    viewBox: "0 0 56.99 61.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xls_",
    "data-name": "xls ",
    transform: "translate(-1088 -609.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4447",
    "data-name": "Group 4447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    transform: "translate(1081.12 604.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M56.12,31.38H53.25V5.12a1,1,0,0,0-1-1H11.75a1,1,0,0,0-1,1V31.38H7.88a.99.99,0,0,0-1,1V51.62a.99.99,0,0,0,1,1h2.87v6.26a1,1,0,0,0,1,1h40.5a1,1,0,0,0,1-1V52.62h2.87a.99.99,0,0,0,1-1V32.38A.99.99,0,0,0,56.12,31.38Zm-4.87,26.5H12.75V52.62h38.5ZM17.55,36.65a.252.252,0,0,1,.21-.391h2.53a.244.244,0,0,1,.21.12l1.94,3.11,1.9-3.11a.272.272,0,0,1,.21-.12H27.07a.261.261,0,0,1,.22.13.27.27,0,0,1-.01.261l-3.25,5.069L27.6,47.11a.244.244,0,0,1,.021.26.261.261,0,0,1-.22.13h-2.62a.247.247,0,0,1-.21-.12L22.4,44l-2.181,3.38a.225.225,0,0,1-.21.12h-2.6a.261.261,0,0,1-.22-.13.246.246,0,0,1,.02-.26l3.57-5.46Zm18.58,8.54a.253.253,0,0,1,.25.25v1.81a.254.254,0,0,1-.25.25H28.57a.247.247,0,0,1-.25-.25V36.6a.247.247,0,0,1,.25-.25h2.17a.254.254,0,0,1,.25.25v8.591h5.14Zm7.14-1.55a1.673,1.673,0,0,0-.67-.39c-.25-.08-.819-.24-1.71-.46a6.1,6.1,0,0,1-2.56-1.12,3.053,3.053,0,0,1-1.07-2.34,3.013,3.013,0,0,1,.51-1.68,3.171,3.171,0,0,1,1.45-1.181,5.64,5.64,0,0,1,2.21-.39,4.8,4.8,0,0,1,3.21.95,3.387,3.387,0,0,1,1.16,2.54.254.254,0,0,1-.24.26l-2.17.1a.26.26,0,0,1-.26-.21,1.624,1.624,0,0,0-.5-1.04,2.012,2.012,0,0,0-1.22-.31,2.345,2.345,0,0,0-1.34.34.554.554,0,0,0-.24.47.573.573,0,0,0,.24.46,5.1,5.1,0,0,0,1.89.67,10.632,10.632,0,0,1,2.4.79,3.306,3.306,0,0,1,1.279,1.181,3.664,3.664,0,0,1-.09,3.71,3.377,3.377,0,0,1-1.56,1.29,6.48,6.48,0,0,1-2.44.41,4.941,4.941,0,0,1-3.29-1,4.325,4.325,0,0,1-1.38-2.9.251.251,0,0,1,.05-.19.224.224,0,0,1,.17-.09l2.11-.21a.241.241,0,0,1,.271.21,2.321,2.321,0,0,0,.689,1.41,2.106,2.106,0,0,0,1.41.44,2.133,2.133,0,0,0,1.41-.391,1.054,1.054,0,0,0,.45-.84A.741.741,0,0,0,43.27,43.64Zm7.98-12.26H12.75V6.12h38.5Z",
    fill: "#0b6631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M46.75,13.375H17.25a1,1,0,0,1,0-2h29.5a1,1,0,0,1,0,2Z",
    fill: "#21a366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M46.75,20.375H17.25a1,1,0,0,1,0-2h29.5a1,1,0,0,1,0,2Z",
    fill: "#21a366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M46.75,27.375H17.25a1,1,0,0,1,0-2h29.5a1,1,0,0,1,0,2Z",
    fill: "#21a366"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446",
    transform: "translate(310.99 277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4414",
    "data-name": "Group 4414",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(818 377)",
    fill: "#185c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M58,48A10,10,0,1,0,68,58,10.011,10.011,0,0,0,58,48Zm3.846,10.769H58.769v3.077a.769.769,0,1,1-1.538,0V58.769H54.154a.769.769,0,1,1,0-1.538h3.077V54.154a.769.769,0,1,1,1.538,0v3.077h3.077a.769.769,0,1,1,0,1.538Z",
    transform: "translate(770 329)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlxsDownloadIcon);
export default __webpack_public_path__ + "static/media/xlxs-download-icon.4c411a9eaed4441565359a820b914a1d.svg";
export { ForwardRef as ReactComponent };